var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 26V30H29V26H31ZM19 26V30H18C17.45 30 17 29.55 17 29V26H19ZM24 13C19.03 13 15 17.03 15 22V29C15 30.66 16.34 32 18 32H21V24H17V22C17 18.13 20.13 15 24 15C27.87 15 31 18.13 31 22V24H27V32H31V33H24V35H30C31.66 35 33 33.66 33 32V22C33 17.03 28.97 13 24 13Z",
    fill: "#071E31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportHelp);
export default __webpack_public_path__ + "static/media/supportHelp.dde3499042fde430a4b9cb2bd909246b.svg";
export { ForwardRef as ReactComponent };